export default "__VITE_ASSET__cRhcLQtk__"